import { render } from "./SelectBox.vue?vue&type=template&id=54e4676c&scoped=true"
import script from "./SelectBox.vue?vue&type=script&lang=ts"
export * from "./SelectBox.vue?vue&type=script&lang=ts"

import "./SelectBox.vue?vue&type=style&index=0&id=54e4676c&scoped=true&lang=css"
import "./SelectBox.vue?vue&type=style&index=1&id=54e4676c&lang=css"
script.render = render
script.__scopeId = "data-v-54e4676c"

export default script